import React from "react";
import HumanResources from "../modules/HumanResources/HumanResources";

export default function HumanResorucesPage() {
  return <HumanResources />;
}
